import React from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';
import * as Styles from './_projectManagement.module.scss';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import ActionButton from '~components/atoms/ActionButton';
import combinedActions from '~redux/combinedActions';
import ProjectManagementSearchAndFilterBar from './ProjectManagementSearchAndFilterBar';
import ProjectManagementTable from './ProjectManagementTable';
import ProjectManagementCreateProjectModal from './ProjectManagementCreateProjectModal';
import ProjectManagementProjectDetailsModal from './ProjectManagementProjectDetailsModal';
import ConfirmUpdateStatusProjectModal from './ConfirmUpdateStatusProjectModal';
import ProjectManagementTablePaginator from './ProjectManagementPagination';

const ProjectManagement = () => {
    const dispatch = useAppDispatch();
    const createAccessModules = useAppSelector(state => state.auth.userDetails.access).find(access => access.permission === PermissionsEnum.Create)?.modules || [];
    const projectDetails = useAppSelector(state => state.project.projectDetails);

    const handleCreateNewProjectClick = () => dispatch(combinedActions.projectSetCreateNewProjectModalIsOpen(true));

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Project List'
                    className={Styles.title}
                    size='l'
                    isBold
                />

                <div className={Styles['button-container']}>
                    {createAccessModules.find(module => module === ModuleEnum.Project)
                        && <ActionButton
                            label='+ Create New Project'
                            onClick={handleCreateNewProjectClick}
                        />
                    }
                </div>
            </TabPageHeaderWrapper>

            <ProjectManagementSearchAndFilterBar />

            <ProjectManagementTable />

            <ProjectManagementTablePaginator />

            <>
                <ProjectManagementCreateProjectModal />

                <ProjectManagementProjectDetailsModal />

                <ConfirmUpdateStatusProjectModal currentStatus={projectDetails.status} />
            </>
        </TabPageContainer>
    );
};

export default ProjectManagement;
